import { Delete, TextSnippet, Visibility } from '@mui/icons-material';
import { Box, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import styles from './styles.module.scss';
import FileBoxProps from './types';
const FileBox = ({ name, onDeleteClick, onViewClick, disabled }: FileBoxProps) => {
    const isLongText = name?.length > 40;
    return (
        <Box className={styles.container}>
            <Paper className={styles.paper}>
                <Box className={styles.info}>
                    <Box className={styles.infoLeft}>
                        <TextSnippet className={styles.icon} />
                        <Tooltip title={isLongText ? name : ''}>
                            <Typography variant="body1">
                                {isLongText ? `${name?.slice(0, 40)}...` : name || "File"}
                            </Typography>
                        </Tooltip>
                    </Box>
                    <Box display="flex" alignItems="center">
                        <IconButton onClick={onViewClick} disabled={disabled}>
                            <Visibility />
                        </IconButton>
                        <Box mx={1} />
                        <IconButton onClick={onDeleteClick} className={styles.deleteBtn} disabled={disabled}>
                            <Delete color='error' />
                        </IconButton>
                    </Box>
                </Box>
            </Paper>
        </Box>

    );
};

export default FileBox;
